/* ==========================================================================
   ZORA — SEO content expand/collapse
   The text is never removed from the DOM — only visually clamped — so crawlers
   and assistive tech always read the whole thing.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.hasAttribute('data-seo-ready')) return;
    root.setAttribute('data-seo-ready', '');

    var body = root.querySelector('[data-z-seo-body]');
    var toggle = root.querySelector('[data-z-seo-toggle]');
    var label = root.querySelector('[data-z-seo-toggle-label]');
    if (!body || !toggle) return;

    var moreText = label ? label.textContent.trim() : 'Read more';
    var lessText = root.getAttribute('data-less-label') || 'Read less';

    // If the copy already fits, the toggle is just noise
    function measure() {
      var clamp = parseInt(getComputedStyle(root).getPropertyValue('--z-seo-clamp'), 10) || 240;
      if (body.scrollHeight <= clamp + 8) {
        body.classList.remove('is-clamped');
        toggle.hidden = true;
      } else if (!body.classList.contains('is-open')) {
        body.classList.add('is-clamped');
        toggle.hidden = false;
      }
    }

    toggle.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      body.classList.toggle('is-clamped', !open);
      body.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.classList.toggle('is-open', open);
      if (label) label.textContent = open ? lessText : moreText;

      if (!open) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    measure();
    window.addEventListener(
      'resize',
      (function () {
        var t;
        return function () {
          clearTimeout(t);
          t = setTimeout(measure, 200);
        };
      })(),
      { passive: true }
    );
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-z-seo]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-z-seo]');
    if (el) init(el);
  });
})();
